// This icon file is generated automatically.
var PDragOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.2 6.91l-1.99-1.57a.11.11 0 00-.18.09v1H7.56V2.98h1.01c.1 0 .15-.11.1-.18l-1.58-2a.11.11 0 00-.18 0l-1.57 2c-.06.07 0 .18.09.18h1v3.47H2.98V5.42c0-.09-.11-.14-.18-.08l-2 1.57a.11.11 0 000 .18l2 1.57c.07.06.18 0 .18-.09v-1h3.47v3.46H5.42c-.09 0-.14.11-.09.18l1.58 2c.04.05.13.05.18 0l1.57-2a.11.11 0 00-.09-.18h-1V7.56h3.46v1.01c0 .1.11.15.18.1l2-1.58a.11.11 0 000-.18z", "fill-rule": "nonzero" } }] }, "name": "p-drag", "theme": "outlined" };
export default PDragOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PDragOutlined.js
// module id = 3346
// module chunks = 0